<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">“I want to prove that ghosts exist, and you guys had an opening in my area of expertise just as I graduated. Kind of seems like fate.”</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“What’s your area?” Blaine liked Flynn’s attitude already, though. He wasn’t going into it predisposed to disbelief. He wanted to prove ghosts existed, like Blaine.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Electromagnetism, biology, and computers. I’ve written a few programs to crunch the data for temperature changes, etc. And they can totally be tweaked as needed. Plus… well, I guess you guys are the ones for whom this is a pro not a con, but I’ve experienced ghosts before.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Yeah? When?” That wasn’t particularly unique. Ghosts were everywhere, and people also got spooked by things that <span style=" font-style: italic; font-size: 1.00em;">weren’t</span> ghosts all the time.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“Most of my life, actually.” Flynn held his gaze for a long moment, and Blaine felt like the guy was testing him. He must have passed because Flynn continued. “My parents died when I was five. Car accident. Every now and then, when I really need her, my mother comes to me.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?6d3b58b7